import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  Input,
  AfterViewInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import {
  NgForm,
  NgModel,
  FormGroup,
  FormBuilder,
  FormControl,
  FormArray,
  Validators,
} from '@angular/forms';
import { PersonService } from 'src/app/shared/services/person.service';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/shared/services/product.service';
import { validaCorreo, validaRut, formateaRut } from '../../helpers/helper';
import { Router, RouterEvent, NavigationStart } from '@angular/router';
import { filter, tap, take } from 'rxjs/operators';
import * as parentesco from './parentesco.json';
import { UbicationService } from 'src/app/shared/services/ubication.service';
import { ICiudad, IComuna, IRegion } from 'src/app/shared/Entities/entities';
// tslint:disable-next-line: max-line-length
import { BeneficiarioModalComponent } from 'src/app/modules/seguro-individual/components/card-beneficiarios/modal/beneficiario-modal/beneficiario-modal.component';
import { DialogStatusMessageComponent } from '../dialog-status-message/dialog-status-message.component';
import { formatDate } from '@angular/common';
import { timer } from 'rxjs';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from '../../enums/insights/event';
import { BiceCrmService } from '@app/shared/services/bice-crm.service';

@Component({
  selector: 'app-dialog-formulario-endoso-beneficiarios',
  templateUrl: './dialog-formulario-endoso-beneficiarios.component.html',
  styleUrls: [
    './dialog-formulario-endoso-beneficiarios.component.sass',
    '../../../../invStyles.sass',
  ],
})
export class DialogFormularioEndosoBeneficiariosComponent
  implements OnInit, AfterViewInit {
  regiones: IRegion[] = [];
  comunas: IComuna[] = [];
  ciudades: ICiudad[] = [];
  colCiudades = [];
  colComunas = [];
  cantidadBeneficiarios: number;
  beneficiarios: FormArray;
  formFooter: FormGroup;
  form = new FormGroup({
    Nombre: new FormControl(),
    Rut: new FormControl(),
    Parentesco: new FormControl(),
    Sexo: new FormControl(),
    Participacion: new FormControl(),
    Prioridad: new FormControl(),
    Direccion: new FormControl(),
    Region: new FormControl(),
    Ciudad: new FormControl(),
    Comuna: new FormControl(),
    OtroParentesco: new FormControl(),
  });
  sumaParticipacion: number;
  sumaGrupos: Array<{
    grupo: number;
    beneficiarios: Array<{ id: number; participacion: number }>;
  }>;
  // LOST FOCUS
  NombreLostFocus: Array<{ id: number; lostFocus: boolean }>;
  ParentescoLostFocus: Array<{ id: number; lostFocus: boolean }>;
  SexoLostFocus: Array<{ id: number; lostFocus: boolean }>;
  ParticipacionLostFocus: Array<{ id: number; lostFocus: boolean }>;
  PrioridadLostFocus: Array<{ id: number; lostFocus: boolean }>;
  DireccionLostFocus: Array<{ id: number; lostFocus: boolean }>;
  RegionLostFocus: Array<{ id: number; lostFocus: boolean }>;
  CiudadLostFocus: Array<{ id: number; lostFocus: boolean }>;
  ComunaLostFocus: Array<{ id: number; lostFocus: boolean }>;
  OtroParentescoLostFocus: Array<{ id: number; lostFocus: boolean }>;

  EmailLostFocus: boolean;
  TelefonoLostFocus: boolean;
  // FIN

  loading = false;
  error = false;
  loadingService = false;
  nombreContratante: string;
  rutContratante: string;
  emailContratante: string;
  ValidaPrioridades = true;
  parentesco = [
    { name: 'Padre/Madre' },
    { name: 'Hijo/a' },
    { name: 'Cónyuge' },
    { name: 'Nieto/a' },
    { name: 'Abuelo/a' },
    { name: 'Conviviente Civil' },
    { name: 'Hermano/a' },
    { name: 'Otro' },
  ];
  invalidCorreo: boolean;
  sexo = [{ name: 'Masculino' }, { name: 'Femenino' }];
  errorFormulario = false;
  // IBM - MTPM: se inicia solamente la prioridad 1, para luego según la cantidad de beneficiarios agregar la prioridad 2 y 3
  prioridad = [{ value: 1 }];
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  successMessage = false;
  formularioSinProblemas = false;

  LineaNegocio: string;

  vidaUrl = environment.url.api + '/';
  mailUrl = environment.service.mail.endpoint_url;
  sumatoriasValidas = false;

  emailDeposito: string;

  isOtroParentesco: boolean[] = [];

  info: string =
    'Para actualizar el mail al cual recibirás la respuesta, ingresa a la sección "mis datos".';
  mostrarInfo: boolean = true;

  botonSolicitarHabilitado: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<
      DialogFormularioEndosoBeneficiariosComponent
    >,
    private dialog: MatDialog,
    private personService: PersonService,
    private ubicationService: UbicationService,
    private productService: ProductService,
    router: Router,
    private appInsightsService: AppInsightsService,
    private biceCrmService: BiceCrmService
  ) {
    // Close dialog ref on route changes
    router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof NavigationStart),
        tap(() => this.dialogRef.close()),
        take(1)
      )
      .subscribe();
  }

  ngOnInit() {
    this.LineaNegocio = this.data.LineaNegocioBen;
    this.sumaGrupos = [];
    this.limpiarFormularioFooter();
    this.loadRegion();
    const dataSubs = this.personService
      .getDatosContratanteProducto(this.data.idPoliza, 'INDIVIDUAL', '')
      .subscribe(
        data => {
          this.nombreContratante = data.Nombre;
          this.rutContratante = data.Rut;
          this.emailDeposito = data.Correo;
        },

        error => {
          this.error = true;

          this.dialogRef.close();
          this.dialog.open(DialogStatusMessageComponent, {
            minWidth: '20vw',
            disableClose: true,
            data: {
              title: 'Ha ocurrido un problema',
              message: 'Intentelo de nuevo más tarde.',
              error: true,
            },
          });
        }
      );
  }
  ngAfterViewInit() {
    const dataSubs = this.personService
      .getDatosContratanteProducto(this.data.idPoliza, 'INDIVIDUAL', '')
      .subscribe(
        data => {
          this.nombreContratante = data.Nombre;
          this.rutContratante = data.Rut;
          this.emailContratante = data.Correo;
        },

        error => {
          this.error = true;

          this.dialogRef.close();
          this.dialog.open(DialogStatusMessageComponent, {
            minWidth: '20vw',
            disableClose: true,
            data: {
              title: 'Ha ocurrido un problema',
              message: 'Intentelo de nuevo más tarde.',
              error: true,
            },
          });
        }
      );
  }
  limpiarFormularioFooter() {
    this.clearLostFocus();
    this.formFooter = new FormGroup({
      telefono: new FormControl('', Validators.required),
      beneficiarios: new FormArray([this.agregaBeneficiario()]),
    });
    this.cantidadBeneficiarios = (this.formFooter.get(
      'beneficiarios'
    ) as FormArray).length;
  }

  OnLostFocus(prm, index) {
    console.log(prm, index);
    switch (prm) {
      case 'Nombre': {
        this.NombreLostFocus[index].lostFocus = true;
        break;
      }
      case 'Parentesco': {
        this.ParentescoLostFocus[index].lostFocus = true;
        break;
      }
      case 'Sexo': {
        this.SexoLostFocus[index].lostFocus = true;
        break;
      }
      case 'Participacion': {
        this.ParticipacionLostFocus[index].lostFocus = true;
        break;
      }
      case 'Prioridad': {
        this.PrioridadLostFocus[index].lostFocus = true;
        break;
      }
      case 'Direccion': {
        this.DireccionLostFocus[index].lostFocus = true;
        break;
      }
      case 'Region': {
        this.RegionLostFocus[index].lostFocus = true;
        break;
      }
      case 'Ciudad': {
        this.CiudadLostFocus[index].lostFocus = true;
        break;
      }
      case 'Comuna': {
        this.ComunaLostFocus[index].lostFocus = true;
        break;
      }
      case 'Telefono': {
        this.validarTelefono();
        this.TelefonoLostFocus = true;
        break;
      }

      case 'OtroParentesco': {
        this.OtroParentescoLostFocus[index].lostFocus = true;
        break;
      }
    }
  }

  IsOtroParentesco(index) {
    let optionSelected = (this.formFooter.get('beneficiarios') as FormArray)
      .at(index)
      .get('Parentesco').value;
    if (optionSelected == 'Otro') {
      this.isOtroParentesco[index] = true;
      (this.formFooter.get('beneficiarios') as FormArray)
        .at(index)
        .get('OtroParentesco')
        .setValue('');
    } else {
      this.isOtroParentesco[index] = false;
      (this.formFooter.get('beneficiarios') as FormArray)
        .at(index)
        .get('OtroParentesco')
        .setValue(' ');
    }
  }

  BrnAgregaBeneficiario(): void {
    if (this.data.from === 'endosos') {
      this.appInsightsService.trackEvent(Event.iideBtnAddBeneficiary);
    } else {
      this.appInsightsService.trackEvent(Event.iidsBtnAddBeneficiary);
    }
    (this.formFooter.get('beneficiarios') as FormArray).push(
      this.agregaBeneficiario()
    );
    this.cantidadBeneficiarios = (this.formFooter.get(
      'beneficiarios'
    ) as FormArray).length;
    // /////////////////////////////////////////////////////////////////////////////////////////////////////
  }
  agregaBeneficiario(): FormGroup {
    this.addLostFocus();
    return new FormGroup({
      Nombre: new FormControl('', Validators.required),
      Rut: new FormControl(''),
      Parentesco: new FormControl('', Validators.required),
      Sexo: new FormControl('', Validators.required),
      Participacion: new FormControl('', Validators.required),
      Prioridad: new FormControl('', Validators.required),
      Direccion: new FormControl('', Validators.required),
      Region: new FormControl('', Validators.required),
      Ciudad: new FormControl('', Validators.required),
      Comuna: new FormControl('', Validators.required),
      OtroParentesco: new FormControl('', Validators.required),
    });
  }
  onClose() {
    this.dialogRef.close();
  }

  addLostFocus() {
    let newid: number;
    if (!this.NombreLostFocus) {
      newid = 0;
    } else {
      newid = this.NombreLostFocus.length;
    }

    this.NombreLostFocus.push({ id: newid, lostFocus: false });

    this.ParentescoLostFocus.push({ id: newid, lostFocus: false });

    this.SexoLostFocus.push({ id: newid, lostFocus: false });

    this.ParticipacionLostFocus.push({ id: newid, lostFocus: false });

    this.PrioridadLostFocus.push({ id: newid, lostFocus: false });

    this.DireccionLostFocus.push({ id: newid, lostFocus: false });

    this.RegionLostFocus.push({ id: newid, lostFocus: false });

    this.CiudadLostFocus.push({ id: newid, lostFocus: false });

    this.ComunaLostFocus.push({ id: newid, lostFocus: false });

    this.OtroParentescoLostFocus.push({ id: newid, lostFocus: false });

    this.isOtroParentesco.push(false);

    console.log(this.NombreLostFocus);
  }

  deleteLostFocus(index) {
    this.NombreLostFocus.splice(index, 1);

    this.ParentescoLostFocus.splice(index, 1);

    this.SexoLostFocus.splice(index, 1);

    this.ParticipacionLostFocus.splice(index, 1);

    this.PrioridadLostFocus.splice(index, 1);

    this.DireccionLostFocus.splice(index, 1);

    this.RegionLostFocus.splice(index, 1);

    this.CiudadLostFocus.splice(index, 1);

    this.ComunaLostFocus.splice(index, 1);

    this.OtroParentescoLostFocus.splice(index, 1);

    this.isOtroParentesco.splice(index, 1);

    console.log(this.NombreLostFocus);
  }

  clearLostFocus() {
    this.NombreLostFocus = [];
    this.ParentescoLostFocus = [];
    this.SexoLostFocus = [];
    this.ParticipacionLostFocus = [];
    this.PrioridadLostFocus = [];
    this.DireccionLostFocus = [];
    this.RegionLostFocus = [];
    this.CiudadLostFocus = [];
    this.ComunaLostFocus = [];
    this.EmailLostFocus = false;
    this.TelefonoLostFocus = false;
    this.OtroParentescoLostFocus = [];
  }

  validarRut(index) {
    (this.formFooter.get('beneficiarios') as FormArray)
      .at(index)
      .get('Rut')
      .setValue(
        formateaRut(
          (this.formFooter.get('beneficiarios') as FormArray)
            .at(index)
            .get('Rut').value
        )
      );

    this.setInvalidField(
      'Rut',
      validaRut(
        (this.formFooter.get('beneficiarios') as FormArray).at(index).get('Rut')
          .value
      ),
      index
    );
  }
  validarTelefono() {
    if (this.formFooter.get('telefono').value.length === 9) {
      this.setInvalidField('telefono', true, 0);
    } else {
      this.setInvalidField('telefono', false, 0);
    }
  }
  setInvalidField(field, isValid, index) {
    if (field === 'telefono') {
      if (!isValid) {
        this.formFooter.get(field).setErrors({ incorrect: true });
      } else {
        this.formFooter.get(field).setErrors(null);
      }
    } else {
      if (!isValid) {
        (this.formFooter.get('beneficiarios') as FormArray)
          .at(index)
          .get(field)
          .setErrors({ incorrect: true });
      } else {
        (this.formFooter.get('beneficiarios') as FormArray)
          .at(index)
          .get(field)
          .setErrors(null);
      }
    }
  }

  cambiarPrioridad(index, prioridad, campoParticipacion) {
    let valorParticipacion = 0;
    let indx = 0;
    let participacion = 0;
    let array;
    valorParticipacion = parseFloat(campoParticipacion.replace(',', '.'));
    for (let i = 0; i < this.sumaGrupos.length; i++) {
      let encuentraBeneficiario = false;
      let indxB = 0;
      for (const y of this.sumaGrupos[i].beneficiarios) {
        if (y.id === index) {
          encuentraBeneficiario = true;
          participacion = y.participacion;
          break;
        }
        indxB++;
      }

      if (encuentraBeneficiario && prioridad !== this.sumaGrupos[i].grupo) {
        array = this.sumaGrupos[i].beneficiarios;
        array.splice(indxB, 1);
        indx = i;
        break;
      }
    }
    if (array) {
      this.agregarGrupoBeneficiarios(index);
    } else if (!array && valorParticipacion > 0) {
      this.agregarGrupoBeneficiarios(index);
    }
  }

  onLostFocus(field, index) {
    const value = (this.formFooter.get('beneficiarios') as FormArray)
      .at(index)
      .get(field).value;
    if (value) {
      if (value >= 100) {
        (this.formFooter.get('beneficiarios') as FormArray)
          .at(index)
          .get(field)
          .setValue('100');
        this.setInvalidField(field, true, index);
      } else {
        if (value === 0) {
          this.setInvalidField(field, false, index);
        } else {
          if (value.toString().length > 5) {
            (this.formFooter.get('beneficiarios') as FormArray)
              .at(index)
              .get(field)
              .setValue(value.toString().substring(0, 5));
            this.setInvalidField(field, true, index);
          } else {
            this.setInvalidField(field, true, index);
          }
        }
      }
    } else {
      this.form.get(field).setValue(0);
      this.setInvalidField(field, false, index);
    }
    this.agregarGrupoBeneficiarios(index);
    this.sumaParticipacion = 0;
    this.sumaGrupos.forEach(x =>
      x.beneficiarios.forEach(y => (this.sumaParticipacion += y.participacion))
    );
  }

  agregarGrupoBeneficiarios(index) {
    // Elimino los grupos que no tengan beneficiarios
    for (let i = 0; i < this.sumaGrupos.length; i++) {
      let sumatoria = 0;
      this.sumaGrupos[i].beneficiarios.forEach(
        x => (sumatoria += x.participacion)
      );
      if (sumatoria === 0) {
        this.sumaGrupos.splice(i, 1);
      }
    }

    const prioridad = (this.formFooter.get('beneficiarios') as FormArray)
      .at(index)
      .get('Prioridad').value;
    if (prioridad) {
      const participacionAdicional = parseFloat(
        (this.formFooter.get('beneficiarios') as FormArray)
          .at(index)
          .get('Participacion')
          .value.replace(',', '.')
      );
      const grpIndx = this.sumaGrupos
        ? this.sumaGrupos.findIndex(x => x.grupo === prioridad)
        : 0;
      // IBM - MTPM: se valida que al ingresar la prioridad 1 se habilite la 2 y si se elige la dos se activa la 3
      if (prioridad === 1 && this.prioridad.length === 1) {
        this.prioridad.push({ value: 2 });
      } else {
        if (prioridad === 2 && this.prioridad.length === 2) {
          this.prioridad.push({ value: 3 });
        }
      }
      // //////////////////////////////////////////////////////////////////////////////////////////////////////////
      if (grpIndx >= 0) {
        const benef = this.sumaGrupos[grpIndx].beneficiarios.find(
          x => x.id === index
        );
        if (!benef) {
          this.sumaGrupos[grpIndx].beneficiarios.push({
            id: index,
            participacion: participacionAdicional,
          });
        } else {
          if (benef.participacion !== participacionAdicional) {
            const benefIndx = this.sumaGrupos[grpIndx].beneficiarios.findIndex(
              x => x.id === index
            );
            this.sumaGrupos[grpIndx].beneficiarios[
              benefIndx
            ].participacion = participacionAdicional;
          }
        }
      } else {
        this.sumaGrupos.push({
          grupo: prioridad,
          beneficiarios: [{ id: index, participacion: participacionAdicional }],
        });
      }
    }
    this.sumatoriasValidas = this.validaPorcentajeGrupos();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode === 46 || charCode === 44) {
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  textOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode === 46 || charCode === 44) {
      return false;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true;
    }
    return false;
  }

  loadRegion() {
    this.ubicationService.getRegiones().subscribe(regiones => {
      this.regiones = regiones.sort((a, b) => {
        const nameA = a.CodigoRegion;
        const nameB = b.CodigoRegion;
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
  }
  regionOnChange(event, index) {
    if (!event) {
      return;
    }
    this.ubicationService.getCiudades(event.value).subscribe(ciudades => {
      if (!ciudades || ciudades.length === 0) {
        return;
      }
      const cityAux = ciudades;
      this.colCiudades[index] = cityAux.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      (this.formFooter.get('beneficiarios') as FormArray).at(index).patchValue(
        {
          Comuna: null,
          Ciudad: null,
        },
        { onlySelf: true, emitEvent: false }
      );
    });
  }
  ciudadOnChange(event, index) {
    if (!event) {
      return;
    }

    this.ubicationService.getComunas(event.value).subscribe(comunas => {
      this.colComunas[index] = comunas.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
  }
  getNombreRegionByCodigo(code: string) {
    return code ? this.regiones.find(x => x.CodigoRegion === code).Nombre : '';
  }

  getNombreCuidadByCodigo(code: string, index) {
    return code
      ? this.colCiudades[index].find(x => x.CodigoCiudad === code).Nombre
      : '';
  }

  getNombreComunaByCodigo(code: string, index) {
    return code
      ? this.colComunas[index].find(x => x.CodigoComuna === code).Nombre
      : '';
  }

  validaPorcentajeGrupos() {
    for (const grupo of this.sumaGrupos) {
      let sumatoria = 0;
      grupo.beneficiarios.forEach(x => (sumatoria += x.participacion));
      if (sumatoria !== 100) {
        this.ValidaPrioridades = false;
        return false;
      }
    }
    this.ValidaPrioridades = true;
    return true;
  }

  deleteBeneficiario(index) {
    if (this.data.from === 'endosos') {
      this.appInsightsService.trackEvent(Event.iideBtnRemoveBeneficiary);
    } else {
      this.appInsightsService.trackEvent(Event.iidsBtnRemoveBeneficiary);
    }

    const prioridad = Number(
      (this.formFooter.get('beneficiarios') as FormArray)
        .at(index)
        .get('Prioridad').value
    );

    if (prioridad !== 0) {
      const grpIndx = this.sumaGrupos.findIndex(x => x.grupo === prioridad);
      const indxBen = this.sumaGrupos[grpIndx].beneficiarios.findIndex(
        x => x.id === index
      );

      this.sumaGrupos[grpIndx].beneficiarios.splice(indxBen, 1);
      this.sumaParticipacion = 0;

      this.sumaGrupos[grpIndx].beneficiarios.forEach(x => {
        this.sumaParticipacion += x.participacion;
        if (x.id > index) {
          x.id -= 1;
        }
      });
      if (this.sumaParticipacion === 0) {
        this.sumaGrupos.splice(grpIndx, 1);
      }
      if (this.deleteBeneficiario && this.cantidadBeneficiarios <= 3) {
        this.prioridad.splice(index);
      } else {
        if (this.deleteBeneficiario && this.cantidadBeneficiarios === 2) {
          this.prioridad.splice(index);
        }
      }
    }
    (this.formFooter.get('beneficiarios') as FormArray).removeAt(index);
    this.colCiudades.splice(index, 1);
    this.colComunas.splice(index, 1);
    this.cantidadBeneficiarios = (this.formFooter.get(
      'beneficiarios'
    ) as FormArray).length;
    this.sumatoriasValidas = this.validaPorcentajeGrupos();
    this.deleteLostFocus(index);
  }
  getValidity(field, index) {
    if (
      (this.formFooter.get('beneficiarios') as FormArray).at(index).get(field)
        .value &&
      !(this.formFooter.get('beneficiarios') as FormArray).at(index).get(field)
        .valid
    ) {
      return true;
    } else {
      return false;
    }
  }
  validaFormularios(index) {
    return (this.formFooter.get('beneficiarios') as FormArray).at(index).valid;
  }

  onSubmit() {
    this.botonSolicitarHabilitado = false;
    if (this.data.from === 'endosos') {
      this.appInsightsService.trackEvent(Event.iideBtnRequestBeneficiary);
    } else {
      this.appInsightsService.trackEvent(Event.iidsBtnRequestBeneficiary);
    }

    this.loadingService = true;
    let i = 0;
    let Description = '';
    const array_beneficiarios = [];

    for (const beneficiario of (this.formFooter.get(
      'beneficiarios'
    ) as FormArray).value) {
      const Region = this.getNombreRegionByCodigo(beneficiario.Region);
      const Ciudad = this.getNombreCuidadByCodigo(beneficiario.Ciudad, i);
      const Comuna = this.getNombreComunaByCodigo(beneficiario.Comuna, i);
      i += 1;

      // IBM - FSM: los datos del beneficiario junto a la prioridad se almacenan en un arreglo
      array_beneficiarios.push({
        Prioridad: beneficiario.Prioridad,
        Beneficiario: i,
        Nombre: beneficiario.Nombre,
        Rut: beneficiario.Rut,
        Parentesco: beneficiario.Parentesco,
        Sexo: beneficiario.Sexo,
        Participacion: beneficiario.Participacion,
        Direccion: beneficiario.Direccion,
        Region,
        Ciudad,
        Comuna,
        OtroParentesco: beneficiario.OtroParentesco,
      });
    }

    // IBM - FSM: El arreglo se ordena por prioridad y se almacena en un nuevo arreglo ordenado
    const array_beneficiarios_sort = array_beneficiarios.sort((a, b) => {
      if (a.Prioridad > b.Prioridad) {
        return 1;
      }
      if (a.Prioridad < b.Prioridad) {
        return -1;
      }
      return 0;
    });

    // IBM - FSM: el arreglo ordenado se recorre para formar el valor final de 'Description'
    let cont = 0;
    for (const ben of array_beneficiarios_sort) {
      cont = cont + 1;
      Description += 'Beneficiario: ' + cont.toString() + '\r\n';
      Description += 'Nombre:' + ben.Nombre + '\r\n';
      Description += 'Rut:' + ben.Rut + '\r\n';
      Description += 'Parentesco:' + ben.Parentesco + '\r\n';
      // "otro" parentesco case
      if (ben.Parentesco == 'Otro') {
        Description += 'Tipo Parentesco:' + ben.OtroParentesco + '\r\n';
      }
      Description += ' Sexo:' + ben.Sexo + '\r\n';
      Description += ' Participación:' + ben.Participacion + '\r\n';
      Description += ' Prioridad:' + ben.Prioridad + '\r\n';
      Description += ' Dirección:' + ben.Direccion + '\r\n';
      Description += ' Región:' + ben.Region + '\r\n';
      Description += ' Ciudad:' + ben.Ciudad + '\r\n';
      Description += ' Comuna:' + ben.Comuna + '\r\n';
      Description += '\n';
    }
    // ////////////////////////////////////
    const detalleSolicitud =
      'ED - Designación y Actualización de Beneficiarios';
    // IBM - FSM : El detalle y el subject deben ser iguales.
    const subject = detalleSolicitud; // 'ED - Designación y Actualización de Beneficiarios';
    const tipoSolicitante = 'Contratante';
    const casoCategoria = 'Endoso IND';

    //llamada salesforce bice
    let fnacimiento = '2000-01-01T10:49:19.091Z';
    let desc = detalleSolicitud + ' - ' + Description;
    var consultationReason = 'Mantencion -S.Individuales';
    var consultationDetail = 'Modificacion De Beneficiarios';
    var businessLine = 'Seguros individuales';
    try {
      this.biceCrmService
        .crearCaso(
          fnacimiento,
          this.formFooter.get('telefono').value,
          this.formFooter.get('telefono').value,
          desc,
          consultationReason,
          consultationDetail,
          businessLine,
          consultationDetail,
          this.data.idPoliza.toString(),
          []
        )
        .subscribe(
          resp => {
            console.log('create case bice - endoso beneficiarios', resp);
            this.botonSolicitarHabilitado = false;
            const date = new Date();
            const dateStr = formatDate(date, 'dd/MM/yyyy', 'es-cl');
            const typeForm = 3;
            const type = null;
            this.productService
              .postSendMail(
                resp.CrmBiceCaseId,
                typeForm,
                this.nombreContratante,
                dateStr,
                type,
                this.data.idPoliza
              )
              .subscribe(
                response => {
                  this.botonSolicitarHabilitado = false;

                  if (!response.response.status) {
                    this.limpiarFormularioFooter();
                    this.loadingService = false;
                    this.formularioSinProblemas = false;
                    this.errorFormulario = true;
                    this.dialog.open(DialogStatusMessageComponent, {
                      minWidth: '20vw',
                      disableClose: true,
                      data: {
                        title: 'Ha ocurrido un problema',
                        message: 'Intentelo de nuevo más tarde.',
                        error: true,
                      },
                    });
                  }
                },
                () => {
                  this.botonSolicitarHabilitado = false;
                  this.limpiarFormularioFooter();
                  this.loadingService = false;
                  this.formularioSinProblemas = false;
                  this.errorFormulario = true;
                  this.dialog.open(DialogStatusMessageComponent, {
                    minWidth: '20vw',
                    disableClose: true,
                    data: {
                      title: 'Ha ocurrido un problema',
                      message: 'Intentelo de nuevo más tarde.',
                      error: true,
                    },
                  });
                }
              );
            this.limpiarFormularioFooter();
            timer(8000).subscribe(x => {
              this.formularioSinProblemas = false;
            });
          },
          () => {
            this.botonSolicitarHabilitado = false;
            this.loadingService = false;
            this.formularioSinProblemas = false;
            this.errorFormulario = true;
            this.dialog.open(DialogStatusMessageComponent, {
              minWidth: '20vw',
              disableClose: true,
              data: {
                title: 'Ha ocurrido un problema',
                message: 'Intentelo de nuevo más tarde.',
                error: true,
              },
            });
          }
        );
    } catch (error) {
      console.log('error crear caso', error);
      this.botonSolicitarHabilitado = false;
    }
  }
}
